import formatSize from './format-size-file/index';
import json from './json/index';

const filters = { formatSize, json };

export default filters;